import React from 'react';
import { InlineSvg } from "./inlineSvg.js";

import { Selectmwupurchase } from './interactive/selectMwuPurchase';
import { Plot } from './plot';

import { EntitiesArray } from './island';

import '../functions/player';
import { Dashboard } from './dashboard';

export class Supplier extends React.Component {
  constructor(props) {
    super(props);

    let mwuBlack = 0;
    if(this.props.object.getExpensesGreen().allMwuBlack + this.props.object.getExpensesGreen().allMwuGreen !== 0){
      mwuBlack = (100 - this.props.object.getExpensesGreen().percentageGreen);
    }

    this.state = {
      isOpen: false,
      funds: this.props.object.funds,
      mwu: this.props.object.getProductionTotal(),
      mwuGreen: this.props.object.getExpensesGreen().percentageGreen || 0,
      mwuBlack: mwuBlack,
      hasNetwork: false,

      facilities: this.props.object.getOwnedServices(),
      upgrades: this.props.object.upgrades,
      purchasedMwu: this.props.object.purchasedMwu,
      soldMwu: this.props.object.soldMwu,
      updatePlots: 0,
      openPlot: {
        1: false,
        2: false
      },
      parentCallback: 'default',
    };

    this.renderPurchaseMwu = this.renderPurchaseMwu.bind(this);
  }

  componentDidMount(){
    this.hasNetwork();
  }

  createAlert = (msg) => {
    this.props.handleAlert(msg);
  }

  getPlots(){
    let plots = [];

    let closeCurrent = false;
    for (var i = 0; i < this.props.object.slots.length; i++) {
      let data = {
        style: {...this.props.object.slots[i].imageStyle},
        owner: this.props.object.name,
        slotNo: i,
      }
      plots.push(<Plot openModal={this.state.openPlot[i + 1]} createAlert={this.createAlert} key={"ePl_" + i + this.props.object.name} update={this.state.updatePlots} handlePurchase={this.handlePurchaseCallback} internal={true} internalData={data}/>)

      if(this.state.openPlot[i + 1]){
        closeCurrent = true;
      }
    }

    if(closeCurrent){
      this.toggleModal();

      this.setState({
        openPlot: {
          1: false,
          2: false
        },
      })
    }

    return plots;
  }

  hasNetwork(){
    this.props.object.getPurchasedUpgrades();
    const gotNetwork = this.props.object.upgrades.filter((current) => {
      return current.name === "Netwerk";
    });
    if(gotNetwork.length > 0) {
      this.setState({
        hasNetwork: true,
      })
    }
  }

  changeDashboard = (pass) => {
    if(pass.type === "upgrade"){
      if (!this.getUpgradeActive(pass.id)) {
        this.refs.dashboard.setState({
          parentCallback: pass,
        });
      }
    } else {
      this.refs.dashboard.setState({
        parentCallback: pass,
      });
    }
  }

  handlePurchaseCallback = (data) => {
    if(data.type === "upgrade"){
      this.purchaseUpgrade(data);
    } else if(data.type === "mwu"){
      this.purchaseMwu(data);
    } else if(data.type === "powerPlant"){
      this.props.handlePurchase(data);
    } else if(data.type === "demolish"){
      this.props.handlePurchase(data);
    }
    this.changeDashboard("default");
  }

  updateVariables = () => {
    let mwuBlack = 0;
    if(this.props.object.getExpensesGreen().allMwuBlack + this.props.object.getExpensesGreen().allMwuGreen !== 0){
      mwuBlack = (100 - this.props.object.getExpensesGreen().percentageGreen);
    }

    this.setState({
      employees: this.props.object.employees,
      funds: this.props.object.funds,
      mwu: this.props.object.getProductionTotal(),
      mwuNecessity: this.props.object.getMwuNecessity(),
      mwuGreen: this.props.object.getExpensesGreen().percentageGreen,
      mwuBlack: mwuBlack,

      facilities: this.props.object.occupiedServiceSlots,
      upgrades: this.props.object.upgrades,
      purchasedMwu: this.props.object.purchasedMwu,
      soldMwu: this.props.object.soldMwu,
      updatePlots: this.state.updatePlots + 1,
    });
    this.hasNetwork();
  }

  purchasePowerPlant = (purchaseData) => {
    if(purchaseData.name !== false){
      const res = this.props.object.purchaseServices(purchaseData);
      if(res[0] === false){
        this.createAlert("Het is niet gelukt om de centrale te kopen. Controleer de ingevulde gegevens. " + res[1])
        return;
      }
      this.props.handlePurchase({
        market: parseInt(purchaseData.price, 10),
        buyWith: (purchaseData.buyWith === false ? false : purchaseData.buyWith.name)
      });
      this.updateVariables();
    } else {
      this.createAlert("Je moet een centrale selecteren voordat je die kunt kopen.")
    }
  };

  purchaseUpgrade = (purchaseData) => {
    if(purchaseData.name !== false){
      const res = this.props.object.purchaseUpgrade(purchaseData.name, purchaseData.marketPrice, purchaseData.subsidy);
      if(res !== true){
        this.createAlert("Het is niet gelukt om de upgrade te kopen. Controleer de ingevulde gegevens. " + res)
        return;
      }
      this.props.handlePurchase({ market: parseInt(purchaseData.marketPrice, 10) });
      this.updateVariables();
    } else {
      this.createAlert("Je moet een upgrade selecteren voordat je die kunt kopen.")
    }
  };

  demolishCentral = (data) => {
    if(data.name !== false){
      data.entities = this.props.entities;
      const res = this.props.object.demolishCentral(data);
      if(res !== true){
        this.createAlert("Het is niet gelukt om de centrale te slopen. Controleer de ingevulde gegevens. " + res)
        return;
      }

      this.props.handlePurchase({ buyWith: data.buyWith });
      this.updateVariables();
    } else {
      this.createAlert("Je moet een centrale selecteren voordat je die kunt slopen.")
    }
  };

  getUpgradeActive = (id) => {
    const upgrades = this.props.object.upgrades;
    if(upgrades.find((current) => {return current.id === id}) === undefined){
      return false;
    } else {
      return true;
    }
  }

  purchaseMwu = (purchaseData) => {
    this.props.object.purchaseMwuFromEntity(purchaseData);
    this.updateVariables();
    this.props.handlePurchase({buyWith: purchaseData.entityToBuyFrom.name});
  };

  toggleModal = () => {
    this.refs.dashboard.handleModaltoggle();
  }

  renderPurchaseMwu(hasNetwork){
    if(hasNetwork){
      return <Selectmwupurchase callbackPurchase={this.purchaseMwu} hasNetwork={this.state.hasNetwork} self={this.props.object.name} entities={EntitiesArray}/>
    } else {
      return <em>Player has to purchase network upgrade first.</em>
    }
  }

  openPlantModal = (e) => {
    const target = e.currentTarget.dataset.id;

    let current = this.state.openPlot;
    current[target] = true;

    this.setState({
      openPlot: current,
    })
  }

  getPlotButtons = () => {
    const plants = this.props.object.getOwnedServices().filter((current) => { return current.external === false});

    let buttons = [];

    let nth = 0;
    for (var i = 0; i < plants.length; i++) {
      nth++
      buttons.push(
        <div key={"btn_-"+i} className="col col--upgrade" data-id={nth} onClick={this.openPlantModal}>
          <div className="upgrade">
            <div className="upgrade--image clickAble">
              <InlineSvg className="svg" src={require("../assets/elements/"+ plants[i].icon +".svg")}/>
            </div>
            <div className="upgrade--name">{ plants[i].name }</div>
          </div>
        </div>
      )
    }

    if(buttons.length < 2){
      const toAdd = 2 - buttons.length;
      for (var ix = 0; ix < toAdd; ix++) {
        nth++
        buttons.push(
          <div key={"btnx_-"+ix} className="col col--upgrade" data-id={nth} onClick={this.openPlantModal}>
            <div className="upgrade">
              <div className="upgrade--image clickAble">
                <InlineSvg className="svg" src={require("../assets/elements/Icon - add source.svg")}/>
              </div>
              <div className="upgrade--name">Nieuwe centrale</div>
            </div>
          </div>
        )
      }
    }

    return buttons;
  }

  render() {

    let classVar = "entityWrap";
    if(this.props.front === true){
      classVar = classVar + " entityWrap--front";
    }

    return(
      <div className={classVar}>
        <div className="hud" style={this.props.object.imageStyle} onClick={this.toggleModal}>
          <div className="inner" style={this.props.object.hudStyle}>
            <div className="hudContent" style={{paddingBottom: "50%"}}>
              <div className="name" style={{backgroundColor: this.props.object.color}}>
                <div className="name-text">{this.props.object.name}</div>
                <div className="name-network"><InlineSvg className={(this.getUpgradeActive(1) === true) ? "svg svg--blend active" : "svg svg--blend"}  src={require("../assets/elements/Icon - network hud.svg")}/></div>
              </div>
              <ul className="data">
                <li className="icon icon--funds">{this.state.funds.toFixed(0)}</li>
                <li className="icon icon--powerProduction">{this.state.mwu.toFixed(0)} MWU</li>
                <li className="icon icon--green">{this.state.mwuGreen.toFixed(0)}%</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="boardElement--road back supplier" style={this.props.object.imageStyle}></div>
        <img className="boardElement boardElement--main" src={this.props.object.image} alt='Board Element' style={this.props.object.imageStyle}/>
        <div className="boardElement--road front supplier" style={this.props.object.imageStyle}></div>
        {this.getPlots()}
        <Dashboard createAlert={this.createAlert} callbackPurchase={this.handlePurchaseCallback} parentCallback={this.state.parentCallback} ref="dashboard" headerText={this.props.object.name} self={this.props.object}>
          <div className="row">
            <div className="col col--data">
              <table>
                <tbody>
                  <tr>
                    <td>Elektriciteitsproductie</td>
                    <td className="value">{this.state.mwu.toFixed(0)}</td>
                    <td>MWU</td>
                  </tr>
                  <tr>
                    <td>Duurzaam</td>
                    <td className="value">{this.state.mwuGreen.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                  <tr>
                    <td>Fossiel</td>
                    <td className="value">{this.state.mwuBlack.toFixed(0)}</td>
                    <td>%</td>
                  </tr>
                </tbody>
              </table>
              <div className="funds">
                <div className="funds-label">Beschikbaar budget</div>
                <div className="funds-value">{this.state.funds.toFixed(0)}</div>
              </div>
            </div>
            <div className="col col--upgrade" onClick={() => {this.changeDashboard({type: "upgrade", id: 1, data: {mwu: this.state.mwu, mwuGreen: this.state.mwuGreen}})}}>
              <div className="upgrade">
                <div className="upgrade--image">
                  <InlineSvg className={(this.getUpgradeActive(1) === true) ? "svg active" : "svg"} src={require("../assets/elements/Icon - network.svg")}/>
                </div>
                <div className="upgrade--name">Netwerk</div>
              </div>
            </div>
          </div>
          <div className="row">
            {this.getPlotButtons()}
          </div>
        </Dashboard>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/supplier.js